import {useState, useEffect} from 'react'

import './backhand_style.css';
import './backhand_media-queries.css';

import m_1 from './assets_2/m_1.png';

import { useDisconnect, useAccount } from 'wagmi';

import { Dashboard_Form, Slots_Form, Rank_Income_Form, Refferal_Income_Form, Matrix_Income_Form, Pool_Income_Form, Team_Tree_Form } from './Data_Structure';
import { Address_ID_Detail, Sub_Variable } from "./Data_Structure";

export default function CoreUnity_After_Login(props) {
    const {address} = useAccount();
    // const address = "0xD8777401C49C5B13BE55f7E754422B1AC3E879d0";
    // const address = "0x5D1Cb9Ee56D7e47E6344868351E744Fb79CE3a66";
    // const address = "0x6328bfb217Ec373B2Aa085fd2b91aB6073ffCA14";

    const { disconnect } = useDisconnect();

    const [ID_, SetID_] = useState();
    const [ID_Type_, SetID_Type_] = useState();
    const [Wallet_Bal, SetWallet_Bal] = useState(Number(0));

    const [CurrentForm, SetCurrentForm] = useState('SLOTS');

    const Load_Main_Data = () => {
        try {
            Address_ID_Detail(address, SetID_, SetID_Type_, SetWallet_Bal);
        }
        catch(error) {
            console.log(error);
        }
    }

    useEffect(() => {
        try {
            // SetID_("589864235");
            // SetID_Type_("S0");

            props.SetIsLogin(true);

            Load_Main_Data();

            // (id__, id_type__) = Address_ID_Detail(address);
            // SetID_(id__);
            // SetID_Type_(id_type__);
        }
        catch(error) {
            console.log(error);
        }
    }, [address, ID_]);

  return (
    <>
        <input type="checkbox" id="nav-toggle"/>
        <div className="sidebar">
            <div className="sidebar-brand">
                <div className="back-grid-brand">
                    <span>Core Unity</span>
                </div>
            </div>
            <div className="sidebar-menu">
                <ul>
                    <li>
                        <a className="active" onClick={() => {SetCurrentForm("DASHBOARD");}}>
                            <span>
                            </span>
                            <span className="menu-tags">Dashboard</span>                      
                        </a>
                    </li>
                    <li>
                        <a className="active-2" onClick={() => {SetCurrentForm("SLOTS");}}>
                            <span></span>
                            <span className="menu-tags">Slots</span>
                        </a>
                    </li>
                    <li>
                        <a className="active-2" onClick={() => {SetCurrentForm("RANK INCOME");}}>
                            <span></span>
                            <span className="menu-tags">Rank Income</span>
                        </a>
                    </li>
                    <li>
                        <a className="active-2" onClick={() => {SetCurrentForm("REFERRAL INCOME");}}>
                            <span></span>
                            <span className="menu-tags">Referral Income</span>
                        </a>
                    </li>
                    <li>
                        <a className="active-2" onClick={() => {SetCurrentForm("LEVEL INCOME");}}>
                            <span></span>
                            <span className="menu-tags">Level Income</span>
                        </a>
                    </li>
                    <li>
                        <a className="active-2" onClick={() => {SetCurrentForm("POOL INCOME");}}>
                            <span></span>
                            <span className="menu-tags">Pool Income</span>
                        </a>
                    </li>
                    {/*<li>
                        <a className="active-2" onClick={() => {SetCurrentForm("TEAM TREE");}}>
                            <span></span>
                            <span className="menu-tags">Team Tree</span>
                        </a>
                    </li>*/}
                    <li>
                        <a className="active" onClick={() => {disconnect();}}>
                            <span></span>
                            <span className="menu-tags">Log Out</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        {/* <!--------Main--Content--------------------------> */}
        <div className="main-content">
            <header>
                <label for="nav-toggle">
                    <div className="back-grid-m"><img src={m_1} alt=""/></div>
                </label>
                <div className="back-grid-header user-wrapper scroll-bar"> 
                    <div className="wallet">
                        <span>Wallet </span>
                        <span>{Sub_Variable(address)}</span> 
                        <div className="wallet-fund">
                            <span>Wallet_Fund </span>
                            <span>{Wallet_Bal} CORE</span>
                        </div>
                    </div>                                 
                </div>
            </header>
            {/* <!--------Main----Cards-----------------------> */}
            <main> 
                {
                    CurrentForm === "DASHBOARD" ? (
                        <>   
                            <Dashboard_Form SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert} address={address} ID_={ID_} ID_Type_={ID_Type_}/>
                        </>
                    ) : CurrentForm === "SLOTS" ? (
                        <>
                            <Slots_Form SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert} address={address} ID_={ID_} ID_Type_={ID_Type_} Load_Main_Data={Load_Main_Data}/>  
                        </>
                    ) : CurrentForm === "RANK INCOME" ? (
                        <>
                            <Rank_Income_Form address={address} ID_={ID_} ID_Type_={ID_Type_}/>
                        </>
                    ) : CurrentForm === "REFERRAL INCOME" ? (
                        <>
                            <Refferal_Income_Form address={address} ID_={ID_} ID_Type_={ID_Type_}/>
                        </>
                    ) : CurrentForm === "LEVEL INCOME" ? (
                        <>
                            <Matrix_Income_Form address={address} ID_={ID_} ID_Type_={ID_Type_}/>
                        </>
                    ) : CurrentForm === "POOL INCOME" ? (
                        <>
                            <Pool_Income_Form SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert} address={address} ID_={ID_} ID_Type_={ID_Type_}/>
                        </>
                    ) : (
                        <></>
                    )
                }                    
            </main>
        </div>
    </>
  )
}

// CurrentForm === "TEAM TREE" ? (
//                         <>
//                             <Team_Tree_Form address={address} ID_={ID_} ID_Type_={ID_Type_}/>
//                         </>
//                     ) : 
